<template>
  <base-page>
    <base-list-table :data="data" :structure="structure" :refreshFunction="refreshPage" />
  </base-page>
</template>

<script>
  import { watch, computed } from 'vue';
  import { useStore } from 'vuex';
  import { useRoute } from 'vue-router';

  export default {
    setup() {
      const store = useStore();
      const route = useRoute();
      const refreshPage = () => store.dispatch('getTripMessages', { id: route.params.tripId });

      const messages = computed(() => store.getters.tripMessages);
      watch(() => route.params.tripId, refreshPage);

      const lastHeartbeat = computed(() => store.getters.lastHeartbeat);
      watch(lastHeartbeat, refreshPage);

      const structure = {
        title: 'Lista Messagi',
        data: [
          {
            title: 'ID',
            fields: [
              {
                placeholder: '@',
                name: '_id',
                class: 'text-primary-400',
              },
              {
                name: 'IMEI',
                class: 'font-bold ',
              },
            ],
            span: 1,
          },
          {
            title: 'Creazione',
            field: 'created_at',
            span: 1,
            class: 'text-style',
            format: 'datetime',
          },
          {
            title: 'Viaggi',
            field: 'trips',
            span: 2,
          },
          /* {
                    title: "ID Evento",
                    field: "message",
                    subField: "event_id",
                    span: 1,
                }, */
          {
            title: 'Dati GPS',
            field: 'message',
            subField: 'gps',
            format: 'gps',
            span: 2,
          },
          {
            title: 'Priorità',
            field: 'message',
            subField: 'priority',
            format: 'priority',
            span: 1,
          },
          {
            title: 'timestamp',
            field: 'message',
            subField: 'timestamp',
            format: 'datetime',
            span: 1,
          },
        ],
      };

      return {
        data: messages,
        structure,
        refreshPage,
      };
    },
  };
</script>

<style></style>
